// Lo marcado en «Elige el teléfono» y el «Sin promo» por sesión del wizard, para sobrevivir un F5.
import { PHONE_DRAFT_STORAGE_PREFIX } from '../constants';
import type { PhoneDraft } from './phoneDraft';

export interface StoredDraft {
    phoneDraft?: PhoneDraft;
    saleDeclined?: boolean;
}

/** Lo guardado de la sesión; vacío sin almacenamiento o con un valor ilegible. */
export function readStoredDraft(sessionId: string): StoredDraft {
    try {
        const raw = sessionStorage.getItem(PHONE_DRAFT_STORAGE_PREFIX + sessionId);
        if (!raw) return {};
        const parsed = JSON.parse(raw) as StoredDraft | null;
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
        return {};
    }
}

export function writeStoredDraft(sessionId: string, value: StoredDraft): void {
    try {
        sessionStorage.setItem(PHONE_DRAFT_STORAGE_PREFIX + sessionId, JSON.stringify(value));
    } catch {
        // Sin almacenamiento lo marcado vive solo en memoria.
    }
}

export function clearStoredDraft(sessionId: string): void {
    try {
        sessionStorage.removeItem(PHONE_DRAFT_STORAGE_PREFIX + sessionId);
    } catch {
        // Sin almacenamiento no hay nada que borrar.
    }
}
